<template>
    <div id="Guided">
        <mobileHeader v-if="isMobile == 'Mobile'" touterNum=3></mobileHeader>
        <Header v-else></Header>
        <backhead :title="titleLabel"></backhead>
        <div class="mainbox app-content" :class="{ Mobileclass: isMobile == 'Mobile' }">
            <div :style="{padding: arrList?.length ? '0px' : '0px'}" class="halfbox">
                <div class="half  hand" v-for="(item, index) in arrList" :key="index" v-show="index < 2" @click="todetails(item.id)">
                    <img :src="item.image" alt="">
                    <p class="half_p">{{ item.content }}</p>
                </div>
            </div>
            <!-- <img src="../assets/talk.png" alt="" class="bigpic"> -->
            <div class="list ">
                <div class="box hand" v-for="(item, index) in arrList" :key="index" v-show="index > 1" @click="todetails(item.id)">
                    <img :src="item.image" alt="" class="pic">
                    <p class="tit">{{ item.content }}</p>
                </div>
                <div class="box" v-if="(arrList.length - 2) % 3 == 2"></div>
            </div>
            <!-- <h1 class="app-title" v-if="ldList.length > 0">{{ h1Intro }}</h1> -->
            <!-- <div class="list " style="padding-bottom: 60px;">
                <div class="box hand" v-for="(item, index) in ldList" :key="index" @click="todetails(item.id)">
                    <img :src="item.image" alt="" class="pic">
                    <p class="tit ">{{ item.title }}</p>
                </div>
                <div class="box" v-if="arrList.length % 3 == 2"></div>
            </div> -->
        </div>
    </div>
</template>

<script setup>
    import { ref, watch, computed } from 'vue';
    import { getshowList } from "../utils/gerData";
    import { currentLanguage } from "../utils/lang";
    import { backheadTitles, pageLabels,imageurl } from "../utils/i18nLabels";
    import router from '@/router';
    const isMobile = localStorage.getItem('userAgent')

    const arrList = ref([]);
    const ldList = ref([]);

    const titleLabel = computed(() => backheadTitles.guided[currentLanguage.value || 'zh'])
    const h1Intro = computed(() => pageLabels.guided.intro[currentLanguage.value || 'zh'])
    // 跳详情
    function todetails(id) {
        router.push("/details?pid=9&id=" + id)
    }
    // 获取列表数据
    function getList() {
        let queryParams1 = {
            page: 1,
            pageSize: 100,
            pid: 3
        }
        getshowList(queryParams1).then(res => {
            const data = res.data
            data.list.map(item => {
                item.content = item.content.replace(/<[^>]*>/g, '')
                item.image = item.image ? imageurl + item.image : undefined
            })
            arrList.value = data.list;
        });
        let queryParams2 = {
            page: 1,
            pageSize: 100,
            pid: 9
        }
        getshowList(queryParams2).then(res => {
            const data = res.data
            data.list.map(item => {
                item.image = item.image ? imageurl + item.image : undefined
            })
            ldList.value = data.list;
        });
    }
    getList()

    watch(currentLanguage, () => {
        getList()
    })
</script>

<style scoped>
    #Guided{
        overflow: hidden;
    }
    .mainbox{
        margin-top: 200px;
        text-align: left;
            
        h3{
            font-size: 30px;
            color: #232323;
            margin-bottom: 70px;
            font-weight: normal;
        }
        .halfbox{
            /* padding: 60px; */
            /* align-items: flex-start; */
            .half{
                align-items: flex-start;
               
                /* width: 47%; */
                /* padding: 10px; */
                img{
                    width: 100%;
                     height: 500px;
                     object-fit: cover;
                }
                p{
                    width: 58%;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    /*设置省略号在容器第四行文本后*/
                    -webkit-line-clamp: 8; 
                    overflow: hidden;
                }
                .half_p {
                     padding: 40px 40px 16px 40px; 
                }
            }
        }
        .bigpic{
            width: 100%;
            display: block;
            margin-bottom: 30px;
        }
        h1{
            font-weight: normal;
            margin: 60px 0 30px;
            padding: 0 60px;
        }
        .list{
            flex-wrap: wrap;
            /* padding: 0 60px; */
            align-items: flex-start;

            .box{
                padding: 40px 0;
                width: 32%;
                .pic{
                    width: 100%;
                    height: 240px;
                    object-fit: cover;
                }
                .tit{
                    font-size: 18px;
                    color: #000;
                    margin-top: 10px;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    /*设置省略号在容器第四行文本后*/
                    -webkit-line-clamp: 4; 
                    overflow: hidden;
                }
            }
        }
        /* 最终重构样式调整 */
        .list {
           .hand {
            width: 100%;
            .pic {
                height: 550px;
            }
            .tit {
                padding: 40px 40px 16px 40px; 
            }
           }
        }
        .hand{
            cursor: pointer;
        }
    }
    

    .Mobileclass{
        margin-top: 160px;
        .flex{
            display: block;
        }
        .halfbox{
            padding: 0 22px !important;
            /* height: 200px; */
            .half {
                width: 100%;
                padding: 0;
                margin-bottom: 22px;
                img {
                    height: 200px;
                }
                img,p{
                    width: 100%;
                    padding: 0 !important;
                }
            }
        }
        .list{
            display: block;
            padding: 0 22px;
            .box{
                width: 100%;
                padding: 0;
                .pic {
                    height: 200px;
                }
                .tit{
                    font-size: 20px;
                    margin: 10px 0 40px 0;
                    padding: 0px;
                }
            }
        }
        h1{
            padding: 22px;
            margin: 0;
            color: #232323;
        }
    }
</style>